import { Navigate } from 'react-router-dom';

// project imports
import { GuardProps } from '@/types';
import { useAppSelector } from '@/hooks/useAppSelector';
import Loader from '@/ui-component/Loader';
import { getUserHomePath } from '@/utils/role';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }: GuardProps) => {
    const { isLoggedIn, isInitializing, user } = useAppSelector((state) => state.auth);
    if (isInitializing) {
        return <Loader />;
    }
    if (isLoggedIn) {
        return <Navigate to={getUserHomePath(user)} replace />;
    }

    return children;
};

export default GuestGuard;
